export default __webpack_public_path__ + "static/media/mountain-circle3.aeb886fc.png";